<template>
    <div class="story-maker-sticker story-maker-sticker-product" :class="{edit : isSelected}">
        <img class="img-change-color" :src="require('@/assets/img/instagram/ehf.png')">
        <p class="text-finish" @click="finish">{{ $t('dash.post-creator.story.done') }}</p>
        <div 
            :class="['sticker','sticker-product',`style${stickerInstance.data.styleVariant}`]"
            @click="stickerInstance.nextStyleVariant"
        >
           <div class="icon" :style="{ backgroundColor: stickerInstance.data.color }"></div>
            <p 
                :class="`${stickerInstance.data.font}`"
                :style="{ color: stickerInstance.data.color }"
            >
                {{ stickerInstance.data.products.length == 1 ? stickerInstance.data.products[0].text : `${stickerInstance.data.products.length} produits` }}
            </p>
        </div>
        <div class="options">

            <div class="list-option-text hide-scrollbar">
                <div class="texts">
                    <div 
                        v-for="font in ['modern', 'classic', 'signature', 'editor', 'poster', 'bubble', 'deco', 'squeeze', 'typewriter', 'strong', 'meme', 'elegant', 'directional', 'literature']"
                        :class="[
                            'text',
                            `${font}-font`,
                            font,
                            {active : stickerInstance.data.font == `${font}-font`}
                        ]" 
                        @click="stickerInstance.data.font = `${font}-font`"
                    >
                        {{ font  }}    
                    </div>
                </div>
            </div>

            <div class="list-option-color">
                <div class="pipette">
                    <div 
                        class="icon" 
                        :style="{backgroundColor: pickerColors.hex}" 
                        @click="()=>{ stickerInstance.data.color = pickerColors.hex; colorPickerShow = true; showPipette = true}
                    ">

                    <div 
                        class="picker-color" 
                        v-if="colorPickerShow" 
                        @mouseleave="colorPickerShow = false" 
                        @mousedown="showPipette = false"
                    >
                        <div class="icon-pipette" v-if="eyeDropperIsAccess && showPipette" @mousedown.stop @click.stop="startEyeDropper"></div>
                        <chrome-picker :value="pickerColors" @input="updateFromPicker"/>
                    </div>
                    
                </div></div>
                <div class="color-carousel">
                    <carousel :perPage="1" :adjustableHeight="true" :centerMode="true" @pageChange="()=>{}" >
                        <Slide v-for="(colors,index) in [['#FFFFFF','#000000','#4397EF','#70C04F','#F6CB5B','#F08C34','#EA4857','#D12D69','#B100C0'],['#EA3323','#ED858E','#F7D0D1','#FADAB4','#F5C281','#D18E47','#99643A','#432324','#1D4A29'],['#262626','#363636','#555555','#737373','#999999','#B2B2B2','#C7C7C7','#DBDBDB','#EFEFEF']]" :key="index">
                            <div v-for="colorHexa in colors" class="color" :style="`background-color:${colorHexa}`" @click="()=>{stickerInstance.data.color = colorHexa; pickerColors.hex = colorHexa}"></div>
                        </Slide>
                    </carousel>
                        
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { Carousel, Slide } from 'vue-carousel';
    import { Chrome } from 'vue-color'
    import { EventBus } from '@/event-bus';
    export default {
        components: {
            Carousel,
            Slide,
            'chrome-picker': Chrome,
        },
        props: {
            id: [Number, String],
            isSelected: Boolean,

            stickerInstance: {
                type: Object,
                required: true
            }
        },

        data() {
            return {
                colorPickerShow: false,

                pickerColors: {
                    hex: '#000000',
                },
                
                eyeDropperIsAccess : false,
                showPipette : true,
            }
        },

        mounted () {
            this.eyeDropperIsAccess = window.EyeDropper ? true : false;
        },

        methods: {            

            finish() {
                this.$emit('unselect')
            },

            updateFromPicker(value) {
                this.pickerColors = {
                    hex: value.hex
                }
                this.stickerInstance.data.color = value.hex
            },

            startEyeDropper() {
                if (!window.EyeDropper) return
                this.colorPickerShow = false
                const eyeDropper = new EyeDropper();

                eyeDropper.open().then((result) => {
                    this.stickerInstance.data.color = result.sRGBHex
                    this.pickerColors = {
                        hex: result.sRGBHex
                    }
                }).catch((e) => {
                });
            }
        }
    }
</script>
